import * as React from "react";
import { Box, Grid } from "@mui/material";
import FutworkConfig from "./FutworkConfig";
import GrowupNextConfig from "./GrowupNextConfig";
import FutworkAIConfig from "./FutworkAIConfig";
import AutomatedNdrConfig from "./AutomatedNdrConfig";
import ChannelConfigPage from "./ChannelOrderConfig";
import CODOnHoldConfig from "./CODOnHoldConfig";
import ReturnConfig from "./ReturnConfig";
import MuiTabs from "../../components/MuiTabs";
// import AutoApproveReturn from "./AutoApproveReturn";

function Config() {

    const [active, setActive] = React.useState(0);
    const tabHeaders = [
        {
            label: "Automated NDR via Whatsapp", key: "0"
        },
        {
            label: "Channel Order", key: "1"
        },
        {
            label: "COD On Hold", key: "2"
        },
        {
            label: "Futworks", key: "3"
        },
        {
            label: "Growup Next", key: "4"
        },
        {
            label: "Futworks AI", key: "5"
        },
        {
            label: "Return Config", key: "6"
        }
    ];

    return (
        <>
            <Grid item xs={12} md={4}>
                <Box sx={{ width: '100%', bgcolor: '#fff', boxShadow: 1 }}>
                    <MuiTabs
                        tabs={tabHeaders}
                        active={active}
                        setActive={setActive}
                        sx={{
                            "& .MuiTab-root": {
                                px: 3,
                                py: 2,
                            },
                        }}
                    />
                </Box>
            </Grid>
            {active === 0 && (
                <Grid item xs={12}>
                    <AutomatedNdrConfig />
                </Grid>
            )}
            {active === 1 && (
                <Grid item xs={12}>
                    <ChannelConfigPage />
                </Grid>
            )}
            {active === 2 && (
                <Grid item xs={12}>
                    <CODOnHoldConfig />
                </Grid>
            )}
            {active === 3 && (
                <Grid item xs={12}>
                    <FutworkConfig />
                </Grid>
            )}
            {active === 4 && (
                <Grid item xs={12}>
                    <GrowupNextConfig />
                </Grid>
            )}
            {active === 5 && (
                <Grid item xs={12}>
                    <FutworkAIConfig />
                </Grid>
            )}
            {active === 6 && (
                <Grid item xs={12}>
                    <ReturnConfig />
                </Grid>
            )}
        </>
    )
}

export default Config;
